import React, { useContext } from 'react';
import { BottomNavigation, Button, Container, Grid, IconButton} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { useState } from 'react';
import MenuItemContainer from '../components/MenuItemContainer';
import clsx from 'clsx';
import { useEffect } from 'react';
import { ArrowForwardIos } from '@material-ui/icons';
import { IBookingContent, IBookingItemContent, IDishContent, IEaterGroupContent, IOfficeContent, IPriceModelContent, ISeatingContent, IUserContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { datesAreOnSameDay, extractMonthAndYear, from_YYYYMMDDHHMMSS, prettyDate} from '../../../config/dateFormatting';
import { FrontendApi } from '../../../planEatApi/FrontendApi';
import { IAlreadyBooked, IMenuItem, IMonthYear, IMyBookingsListItem } from '../../../interface/interface';
import { MyBookingsListItem } from '../components/MyBookingsListItem';
import { CustomCheckBox } from '../../../components/ui/CustomCheckBox';
import { v4 } from 'uuid';
import { HamburgerMenu } from '../../../components/ui/HamburgerMenu';
import { OfficeContext, PlanEatUserContext } from '../../../config/Context';
import toast from 'react-hot-toast';
import { isBookingDisabled } from '../../../utils/isBookingDisabled';
import { Logo } from '../../../components/ui/Logo';
import { delay } from '../../../utils/delay';
import { MdSort } from 'react-icons/md';
import { icon_backButton, icon_hamburger } from '../../../assets/images/images';
import { MultiDateCalendarPicker } from '../../../components/ui/MultiDateCalendarPicker';
import { extractErrorMessage } from '../../../components/utils/ErrorHandler';

const useStyles = makeStyles((theme: any) => ({
    topbarContainer: {
        padding: 10,
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    titleContainer: {
        display: 'grid',
        width:"100%",
        gridTemplateColumns: '50% 50%',
        alignItems: 'end',
        justifyContent: 'space-between',
        alignContent: 'center'
    },
    titles: {
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 10
    },
    subTitle: {
        fontSize: 20,
        fontWeight: 700
    },
    dropDownButton: {
        background: 'none',
        backgroundColor: 'none',
        fontSize: 14,
        fontWeight: 700,
        color: 'black !important',
        border: 'none',
        outline: 0,
        width: 'fit-content',
        marginBottom: 13
    },
    flexStart: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        boxSizing: 'border-box'
    },
    bottomNav: {
        color: 'white',
        background: 'linear-gradient(45deg, ' + theme.palette.primary.main + ' 30%, ' + theme.palette.secondary.main + ' 90%)',
        position: 'fixed',
        left: 0,
        bottom: 0,
        height: 50,
        width: '100%',
        paddingLeft: 15,
        paddingRight: 10,
        zIndex: 20,
    },
    priceContainer: {
        display: 'flex',
        float: 'left',
        justifyContent: 'center !important',
        alignContent: 'center !important'
    },
    priceText: {
        fontSize: 28,
        paddingRight: 5
    },
    currencyText: {
        fontSize: 12,
        margin: 'auto'
    },
    datePickerContainer: {
        display: 'flex',
        justifyContent: 'center !important',
        alignContent: 'center !important',
        marginTop: 10,
        marginBottom: 10
    },
    continueButton: {
        cursor: 'pointer'
    },
    root: {
        width: '100%',
        padding: 10,
        background: '#FFFFFF',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
    seatingContainer: {
        minWidth: '46%',
        margin: '2%'
    },
    timesAndOption: {
        fontSize: 16,
        fontWeight: 700
    },
    menuItemContainer: {
        marginTop: 10,
    },
    menuItemsContainer: {
        width: '100%',
        marginTop: 15,
    },
    myBookingsContainer: {
        marginTop: 25,
        marginBottom: 100,
    },
    noBookingsOnDateContainer: {
        fontSize: 16,
        fontWeight: 700,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '15svh',
        color: '#AAAAAA',
        margin: 'auto'
    },
    checkOutBookingContainer: {
        paddingBottom: 15
    },
    bookingInfoContainer: {
        paddingTop: 40,
        paddingBottom: 5,
        borderBottom: '1px dashed #000000',
        "& > div": {
            marginBottom: 10
        }
    },
    checkOutSeatingInfoContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: 5
    },
    checkOutSeatingInfoBold: {
        fontSize: 14,
        fontWeight: 700
    },
    checkOutSeatingInfoNormal: {
        fontSize: 14,
        fontWeight: 400
    }, checkOutTotalContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: 20
    },
    checkOutPriceBold: {
        fontSize: 20,
        fontWeight: 700
    },
    checkOutPriceNormal: {
        fontSize: 12,
        fontWeight: 400
    },
    checkOutPriceContainer: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'end',
        lineHeight: 0.8
    },
    checkOutPaymentContainer: {
        cursor: 'pointer',
        display: 'grid',
        gridTemplateColumns: '20% 80%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
        padding: 12,
        marginTop: 40
    },
    newBookingContainer: {
        padding: 10,
        marginTop: 10,
        width: '100%',
        fontSize: 22,
        fontWeight: 700,
    },
    upcomingBookingsHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: 20
    },
    flexEnd:{
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
    }
}));


export const Booking: React.FC = () => {
    const classes = useStyles();

    // Date mechanisms
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const [minDate,setMinDate] = useState<Date>(new Date())
    const [countDownTo, setCountDownTo] = useState<Date>(new Date())

    // Context
    const officeContext = useContext(OfficeContext);
    const planEatUserContext = useContext(PlanEatUserContext);

    // Sidebar flag
    const [open, setOpen] = useState(false);

    // Booking mechanisms
    const [booking, setBooking] = useState<IBookingContent>();
    const [bookedForToday, setBookedForToday] = React.useState(false);
    const [newBooking, setNewBooking] = React.useState(false);
    const [price, setPrice] = React.useState(0);
    const [priceTotal, setPriceTotal] = React.useState(0);
    const [sortClosestBookingFirst,setSortClosestBookingFirst] = React.useState(true);
    const [isCorrectlyBooked,setIsCorrectlyBooked] = React.useState(false);

    const [seatingsAvaialable, setSeatingsAvaialable] = useState<Map<string,string>>(new Map())
    const [seatingCapacities, setSeatingCapacities] = useState<Map<string,string>>(new Map())

    // Checkout
    const [isItemsSelected, setIsItemsSelected] = useState(false)
    const [showCheckOut, setShowCheckOut] = React.useState(false);
    const [checkOutView, setCheckOutView] = useState<any[]>([]);
    const [checkOutPaymentOption, setCheckOutPaymentOption] = useState<string>('invoice');

    // MenuItems
    const [menuItemsOnDate, setMenuItemsOnDate] = useState<IMenuItem[]>([]);
    const [menuItemsOnDateView, setMenuItemsOnDateView] = useState<any[]>([]);

    // Upcoming bookings
    const [myBookingList, setMyBookingList] = useState<IMyBookingsListItem[]>([]);
    const [myBookingListView, setMyBookingListView] = useState<any[]>([]);

    // Entities
    const [users, setUsers] = useState<IVersionedObject<IUserContent>[]>([]);
    const [eaterGroups, setEaterGroups] = useState<IVersionedObject<IEaterGroupContent>[]>([]);
    const [offices, setOffices] =  useState<IVersionedObject<IOfficeContent>[]>();
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>();
    const [bookings,setBookings] = useState<IVersionedObject<IBookingContent>[]>();
    const [dishes,setDishes] = useState<IVersionedObject<IDishContent>[]>();
    const [priceModels,setPriceModels] = useState<IVersionedObject<IPriceModelContent>[]>();
    const [monthYear, setMonthYear] = useState<IMonthYear>({month:0,year:0})
    
    async function retrievePageInfo(){
        await getDatabase()
    }

    /*Get required info */
    async function getDatabase(){
        await planEatApi.getSeatings()
        .then((response) => {setSeatings(response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id));return response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id)})
        .catch((e) => {console.log(e)});

        await planEatApi.getBookings()
        .then((response) => {setBookings(JSON.stringify(bookings) !== JSON.stringify(response.data) ? response.data : bookings)})
        .catch((e) => {console.log(e)})
        
        await planEatApi.getDishes()
        .then((response) => {setDishes(JSON.stringify(dishes) !== JSON.stringify(response.data) ? response.data : dishes)})
        .catch((e) => {console.log(e)})

        await planEatApi.getPriceModels()
        .then((response) => {setPriceModels(JSON.stringify(priceModels) !== JSON.stringify(response.data) ? response.data : priceModels)})
        .catch((e) => {console.log(e)});

        await planEatApi.getUsers()
        .then((response) => {setUsers(JSON.stringify(users) !== JSON.stringify(response.data) ? response.data : users)})
        .catch((e) => {console.log(e)});

        await planEatApi.getEaterGroups()
        .then((response) => {setEaterGroups(JSON.stringify(users) !== JSON.stringify(response.data) ? response.data : eaterGroups)})
        .catch((e) => {console.log(e)});
    }


    /* Init selected date*/
    useEffect(() => {
        if(officeContext?.office){
            getMinDate(officeContext.office.content.id)
            getOffices()
            retrievePageInfo();
        }
    }, [officeContext]);

    const getMinDate = (officeId: string) => {
        planEatApi.getNextSelectableSeatingDate(officeId)
        .then(response => {
            var tmpMinDate = from_YYYYMMDDHHMMSS(response.data)
            //setMinDate(tmpMinDate)
            
            if(selectedDate && selectedDate.getTime() < tmpMinDate.getTime()){
                //setSelectedDate(tmpMinDate);
            } else{
                //setSelectedDate(tmpMinDate);
            }
        })
        .catch(e => {
            console.log(e)
        })
    }

    const getOffices = async () => {
        await planEatApi.getOffices().then((response) => {
            setOffices(response.data)
        })
    }

    useEffect(() => {
        if(officeContext?.office && selectedDate){
            getMyBookingList();
            getMenuItemsOnDate(officeContext.office.content.id,selectedDate);
        }
    }, [officeContext, selectedDate, bookings, seatings, dishes, priceModels]);


    const getMyBookingList = async () => {
        if(bookings && seatings && dishes){
            FrontendApi.getMyBookingsList(true, false, bookings, seatings, dishes)
            .then(response => {
                setMyBookingList(response);
                displayUpcomingBookings(response)
            })
            .catch(e => {
                console.log(e); 
            })
        }
    }

    const getMenuItemsOnDate = async (officeId: string, tmpDate: Date) => {
        if(bookings && seatings && dishes && priceModels){
            await FrontendApi.getMenuItemsOnDate(tmpDate,officeId,seatings,dishes,bookings,priceModels)
            .then(response => {
                setMenuItemsOnDate(response)
                getSeatingCountDown(response)
            })
            .catch(e => {
                console.log(e)
            })
        }
    }

    const getSeatingCountDown = (menuItemsOnDate: IMenuItem[]) => {
        if(menuItemsOnDate.length > 0){
            if(menuItemsOnDate[0].selectableSeatings.length > 0){
                planEatApi.getSeatingCountDown(menuItemsOnDate[0].selectableSeatings[0].seating.content.id)
                .then(response => {
                    setCountDownTo(from_YYYYMMDDHHMMSS(response.data))
                })
                .catch(e => {
                    console.log(e)
                })
            }
        }
    }

    useEffect(() => {
        getAvailableDays()
        getSeatingCapacities()
    },[menuItemsOnDate])

    function getAvailableDays(){
        var seatingIds: string[] = []
        menuItemsOnDate.forEach(menuItemOnDate => {
            menuItemOnDate.selectableSeatings.forEach(selectableSeating => {
                if(!seatingIds.includes(selectableSeating.seating.content.id)){
                    seatingIds.push(selectableSeating.seating.content.id)
                }
            })
        })

        planEatApi.getCutOffTime(seatingIds)
        .then(response => {
            var tmpResponse: Object = JSON.parse(JSON.stringify(response.data))
            setSeatingsAvaialable(new Map<string,string>(Object.entries(tmpResponse)))
        })
        .catch(e => {
            console.log(e)
        })
    }

    function getSeatingCapacities(){
        var seatingIds: string[] = []
        menuItemsOnDate.forEach(menuItemOnDate => {
            menuItemOnDate.selectableSeatings.forEach(selectableSeating => {
                if(!seatingIds.includes(selectableSeating.seating.content.id)){
                    seatingIds.push(selectableSeating.seating.content.id)
                }
            })
        })

        planEatApi.getSeatingCapacities(seatingIds)
        .then(response => {
            var tmpResponse: Object = JSON.parse(JSON.stringify(response.data))
            setSeatingCapacities(new Map<string,string>(Object.entries(tmpResponse)))
        })
        .catch(e => {
            console.log(e)
        })
    }
    
    const displayUpcomingBookings = (tmpBookingList: IMyBookingsListItem[]) => {
        if(seatings && bookings && priceModels){
            let myBookingsView : any[] = []
            for (const [index, bookingListItem] of tmpBookingList.entries()) {
                var disabled = isBookingDisabled(bookingListItem.bookingId,seatings,bookings,priceModels)
    
                myBookingsView.push(
                    <MyBookingsListItem 
                    key={bookingListItem.bookingId} 
                    bookingListItem={bookingListItem} 
                    handleDelete={() => handleDelete(bookingListItem.bookingId)} 
                    handleEdit={() => handleEdit(bookingListItem.bookingId)} 
                    disabled={disabled}/>)
            }
            setMyBookingListView(myBookingsView)
        }
    }

    const calculateTotal = () => {
        let tmp_quantity: number = 0;

        if (menuItemsOnDate.length > 0) {
            menuItemsOnDate.forEach((menuItemOnDate) => {
                tmp_quantity += menuItemOnDate.quantity;
            })
        }
        setPriceTotal(tmp_quantity * price)
    }

    function calculatePrice(menuItemsOnDate: IMenuItem[]) {
        if(menuItemsOnDate.length > 0){
            if(menuItemsOnDate[0].selectableSeatings.length > 0){
                planEatApi.getSeatingPrice(menuItemsOnDate[0].selectableSeatings[0].seating.content.id)
                    .then(response => {
                        setPrice(parseInt(response.data))
                    })
                    .catch(e => {
                        setPrice(0)
                    }) 
                }
        }
    }

    const getSelectedSeatings = () => {
        let tmpSelectedSeatings: IVersionedObject<ISeatingContent>[] = [];
        menuItemsOnDate.forEach((menuItemOnDate) => {
            menuItemOnDate.selectableSeatings.forEach((selectableSeating) => {
                if (selectableSeating.selected) {
                    if (tmpSelectedSeatings.length > 0) {
                        let contains = false;
                        tmpSelectedSeatings.forEach((tmpSelectedSeating) => {
                            if (tmpSelectedSeating=== selectableSeating.seating) {
                                contains = true;
                            }
                        })
                        if (!contains) {
                            tmpSelectedSeatings.push(selectableSeating.seating)
                        }
                    } else {
                        tmpSelectedSeatings.push(selectableSeating.seating)
                    }
                }
            })
        })
        return tmpSelectedSeatings;
    }

    const createBookings = async () => {
        let tmpSelectedSeatings: IVersionedObject<ISeatingContent>[] = getSelectedSeatings();
        var tmpBooking: IBookingContent;

        let userId = planEatUserContext?.planEatServiceUser?.content.id;
        if (tmpSelectedSeatings.length > 0 && userId) {
            tmpSelectedSeatings.forEach((selectedSeating) => {
                if (booking !== undefined) {
                    tmpBooking = booking;
                } else {
                    if(userId){
                        tmpBooking = {
                            id: '',
                            name: "",
                            description: "",
                            userId: userId,
                            seatingId: selectedSeating.content.id,
                            seatingVersion: selectedSeating.version,
                            bookingPricePerServing: 0,
                            bookingComment: "",
                            bookingItems: [],
                        };
                    }
                }

                let tmpBookingItem: IBookingItemContent[] = []
                menuItemsOnDate.forEach((menuItemOnDate) => {
                    if (menuItemOnDate.quantity > 0) {
                        menuItemOnDate.selectableSeatings.forEach((selectableSeating) => {
                            if (selectableSeating.selected) {
                                if (selectableSeating.seating === selectedSeating) {
                                    for (let i = 0; i < menuItemOnDate.quantity; i++) {
                                        const bookingItem: IBookingItemContent = {
                                            'bookingItemId': v4(),
                                            'dishId': menuItemOnDate.dish.content.id,
                                            'dishVersion': menuItemOnDate.dish.version
                                        };
                                        tmpBookingItem.push(bookingItem)
                                    }
                                }
                            }
                        })
                        if(menuItemOnDate.comment){
                            tmpBooking.bookingComment = menuItemOnDate.comment
                        }
                    }
                })
                tmpBooking.bookingItems = tmpBookingItem;
                planEatApi.postBooking(tmpBooking)
                .then(_ => {
                    calenderChangesObserver()
                    resetBooking();
                    getDatabase();
                    setBooking(undefined);
                    setSelectedDate(minDate)
                    toast.success("Booking was created")
                })
                .catch(e => {
                    extractErrorMessage(e, "Failed creating booking")
                })
            })
        }
    }

    const resetBooking = async () => {
        setShowCheckOut(false);
        setCheckOutView([]);
        setMenuItemsOnDate([]);
        setMenuItemsOnDateView([]);
        setNewBooking(false);
        setBooking(undefined);

        if(officeContext?.office && selectedDate){
            getMenuItemsOnDate(officeContext.office.content.id, selectedDate)
            getMyBookingList()
        }
    }

    useEffect(() => {
        displayMenuItems();
        calculateTotal();
        checkIfCorrectlyBooked();
        calculatePrice(menuItemsOnDate)
    }, [menuItemsOnDate]);

    const checkIfCorrectlyBooked = () => {
        var tmpIsCorrectlyBooked = true;
        menuItemsOnDate.forEach((menuItemsOnDate) =>{
            if(menuItemsOnDate.quantity > 0){
                let singleSeatingSelected = 0;
                menuItemsOnDate.selectableSeatings.forEach((selectableSeating) => {
                    if(selectableSeating.selected){
                        singleSeatingSelected += 1;
                    }
                })

                if(singleSeatingSelected !== 1){
                    tmpIsCorrectlyBooked = false;
                }
            }
        })
        
        setIsCorrectlyBooked(tmpIsCorrectlyBooked)
    }

    useEffect(() => {
        displayMenuItems()
    },[price, countDownTo, seatingCapacities, seatingsAvaialable])

    const displayMenuItems = () => {
        var userId = localStorage.getItem("userId")
        if(selectedDate && seatings && bookings && offices && userId){
            var eaterGroupBookings: IAlreadyBooked[] = [];
            var currentUser = users.find(user => user.content.id=== userId)
            var eaterGroupUsers: IVersionedObject<IUserContent>[] = []
            if(currentUser){
                users.forEach(user => {
                    if(user.content.eaterGroupId=== currentUser?.content.eaterGroupId){
                        eaterGroupUsers.push(user)
                    }
                })

                // Sort by seating time
                seatings.sort((a,b) => from_YYYYMMDDHHMMSS(a.content.seatingStart).getTime() - from_YYYYMMDDHHMMSS(b.content.seatingStart).getTime())

                seatings.forEach(seating => {
                    // Already booked parameters
                    var quantity: number = 0;
                    var officeName: string = "";

                    var seatingDate = from_YYYYMMDDHHMMSS(seating.content.seatingStart)
                    if(datesAreOnSameDay(seatingDate,selectedDate)){
                        bookings.forEach(booking => {
                            if(booking.content.seatingId === seating.content.id){
                                eaterGroupUsers.forEach(eaterGroupUser => {
                                    if(booking.content.userId === eaterGroupUser.content.id && booking.content.userId !== userId){
                                        quantity += booking.content.bookingItems.length;
                                        
                                        offices.forEach(office => {
                                            if(office.content.id=== seating.content.officeId){
                                                officeName = office.content.officeName;
                                            }
                                        })
                                    }
                                })    
                            }
                        })
                    }

                    if(quantity > 0 && officeName !== ''){
                        var alreadyBooking: IAlreadyBooked = {
                            quantity: quantity,
                            seatingId: seating.content.id,
                            seatingName: seating.content.seatingName,
                            seatingTime: prettyDate(seating.content.seatingStart, true, false),
                            officeName: officeName,
                        }
                        eaterGroupBookings.push(alreadyBooking)
                    }
                })
            }

            var eaterGroupName = eaterGroups.find(eaterGroup => eaterGroup.content.id === currentUser?.content.eaterGroupId)?.content.eaterGroupName;
            const canCommentOnBookings = officeContext?.office?.content.officeSettings ? officeContext?.office?.content.officeSettings.canCommentOnBookings : false
            const menuItemsView = menuItemsOnDate.map((menuItemOnDate, index) =>
                <MenuItemContainer
                    key={v4()}
                    selectedDate={selectedDate}
                    countDownTo={countDownTo}
                    menuItemOnDate={menuItemOnDate}
                    menuItemsOnDate={menuItemsOnDate}
                    price={price}
                    setMenuItemsOnDate={setMenuItemsOnDate}
                    eaterGroupBookings={eaterGroupBookings}
                    eaterGroupName={eaterGroupName ? eaterGroupName : "Eater Group"}
                    seatingCapacities={seatingCapacities}
                    seatingAvailable={seatingsAvaialable}
                    canCommentOnBookings={canCommentOnBookings}
                />
            );
            setMenuItemsOnDateView(menuItemsView)
        }
    }

    const displayCheckOutItems = () => {
        let tmpCheckOutView: any[] = [];
        let selectedSeatings: IVersionedObject<ISeatingContent>[] = getSelectedSeatings();

        selectedSeatings.forEach((selectedSeating, index) => {
            tmpCheckOutView.push(
                <div key={v4()}>
                    <div>
                        <div className={classes.checkOutSeatingInfoBold}>
                            {prettyDate(from_YYYYMMDDHHMMSS(selectedSeating.content.seatingStart), false, true)}
                        </div>
                        <div className={classes.checkOutSeatingInfoNormal}>
                            {selectedSeating.content.seatingName}  |   {prettyDate(from_YYYYMMDDHHMMSS(selectedSeating.content.seatingStart), true, false)}
                        </div>
                    </div>
                </div>
            )
            menuItemsOnDate.forEach((menuItemOnDate, index) => {
                if (menuItemOnDate.quantity > 0) {
                    menuItemOnDate.selectableSeatings.forEach((selectableSeating) => {
                        if (selectableSeating.selected) {
                            if (selectableSeating.seating === selectedSeating) {
                                tmpCheckOutView.push(
                                    <div className={classes.checkOutSeatingInfoContainer} key={v4()}>
                                        <div>
                                            <div className={classes.checkOutSeatingInfoBold}>
                                                Menu Option {index + 1}
                                            </div>
                                            <div className={classes.checkOutSeatingInfoNormal}>
                                                {menuItemsOnDate[index].quantity} x   {menuItemsOnDate[index].dish.content.dishTitle}
                                            </div>
                                        </div>
                                        <div className={classes.checkOutPriceContainer} hidden={priceTotal=== 0}>
                                            <div className={classes.checkOutPriceBold} >
                                                {menuItemsOnDate[index].quantity * price}
                                            </div>
                                            <div className={classes.checkOutPriceNormal}>
                                                DKK
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                    })

                }
            })
        })
        setCheckOutView(tmpCheckOutView);
    }

    useEffect(() => {
        displayCheckOutItems();
    }, [showCheckOut=== true]);


    const handleOfficeChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if(offices){
            offices.map((office) => {
                if(office.content.id=== event.currentTarget.value){
                    officeContext?.setOffice(office)
                    localStorage.setItem("officeId",office.content.id)
                }
            })
        }
    }

    const handleEdit = async (bookingId: string) => {
        await planEatApi.getBooking(bookingId)
        .then(async response => {
            if(seatings){
                const currentSeating = seatings?.find(item => item.content.id === response.data.content.seatingId)
                if(currentSeating){
                    const dateOfSeating = from_YYYYMMDDHHMMSS(currentSeating.content.seatingStart)
                    setSelectedDate(dateOfSeating) 
                    setBooking(response.data.content)
                    getMenuItemsFromBooking(response.data,dateOfSeating)
                }
            }
        })
        .catch(e => {
            console.log(e)
        });
    }

    const getMenuItemsFromBooking = (booking: IVersionedObject<IBookingContent>, dateOfSeating: Date) => {
        if(officeContext?.office && bookings && seatings && dishes){
            FrontendApi.getMenuItemsFromBooking(booking,bookings,seatings,dishes,officeContext.office.content.id,dateOfSeating)
            .then(response => {
                setMenuItemsOnDate(response)
            })
            .catch(e => {
                console.log(e)
            })        
        }
    }

    const handleDelete = async (bookingId: string) => {
        await planEatApi.postDeleteForBooking(bookingId)
            .then(response => {
                toast.success("Booking was deleted");
                retrievePageInfo()
            })
            .catch(e => {
                console.log(e)
                toast.error("Failed deletion of booking");
            });
    }

    const sortFields = () => {
        let sortedArray: any[] = [];
        myBookingList.forEach((booking) => {
            sortedArray.push(booking);
        })

        // Lastes booking first
        if(!sortClosestBookingFirst=== true){
            sortedArray.sort((a, b) => (from_YYYYMMDDHHMMSS(a.seatingStart) > from_YYYYMMDDHHMMSS(b.seatingStart)) ? 1 : (from_YYYYMMDDHHMMSS(a.seatingStart) < from_YYYYMMDDHHMMSS(b.seatingStart)) ? -1 : 0)
        // Closest booking first
        } else if (!sortClosestBookingFirst=== false){
            sortedArray.sort((a, b) => (from_YYYYMMDDHHMMSS(a.seatingStart) < from_YYYYMMDDHHMMSS(b.seatingStart)) ? 1 : (from_YYYYMMDDHHMMSS(a.seatingStart) > from_YYYYMMDDHHMMSS(b.seatingStart)) ? -1 : 0)
        }
        setMyBookingList(sortedArray);
        setSortClosestBookingFirst(!sortClosestBookingFirst)
    }

    useEffect(() => {
        checkIsItemsSelected()
    },[menuItemsOnDate])

    function checkIsItemsSelected(){
        let quantity: number = 0;

        if(menuItemsOnDate.length > 0){
            menuItemsOnDate.forEach(menuItemsOnDate => {
                quantity += menuItemsOnDate.quantity
            })
        }
       setIsItemsSelected(quantity > 0)
    }

    useEffect(() => { 
        calenderChangesObserver()
    },[myBookingList])

    async function calenderChangesObserver(){
        const calenderHeader = document.getElementsByClassName("rmdp-header-values")
        const observer = new MutationObserver((mutationRecords) => {
            const [month, year] = extractMonthAndYear(calenderHeader[0].textContent)
            setMonthYear({month,year})
        })
        if(calenderHeader.length > 0){
            observer.observe(calenderHeader[0], {
                characterData: true,
                subtree: true,
            })
            const [month, year] = extractMonthAndYear(calenderHeader[0].textContent)
            setMonthYear({month,year})
        } else {
            await delay(250);
            calenderChangesObserver();
        }
    }

    useEffect(() => {
        if(monthYear.year !== 0){
            getBookingsInMonth(monthYear.month, monthYear.year)
        }
    },[monthYear, myBookingList])

    function getBookingsInMonth(month: number, year: number){
        var bookingDatesOfMonth: number[] = []
        var seatingDatesOfMonth: number[] = []

        // Get Bookings in selected month
        if(myBookingList.length > 0){
            myBookingList.forEach(upcomingBooking => {
                const seatingDate = from_YYYYMMDDHHMMSS(upcomingBooking.seatingStart);
                if(seatingDate.getMonth()=== month && seatingDate.getFullYear()=== year){
                    bookingDatesOfMonth.push(seatingDate.getDate())
                }
            })
        }

        // Get seatings in selecected month
        if(seatings){
            const today = new Date()
            seatings.forEach(seating => {
                if(seating.content.officeId === officeContext?.office?.content.id){
                    const seatingDate = from_YYYYMMDDHHMMSS(seating.content.seatingStart);
                    if(seatingDate.getMonth() === month && seatingDate.getFullYear() === year){
                        if(today.getMonth() === month && today.getFullYear() === year){
                            if(seatingDate.getDate() >= today.getDate()){
                                seatingDatesOfMonth.push(seatingDate.getDate())
                            }
                        } else {
                            seatingDatesOfMonth.push(seatingDate.getDate())
                        }
                    }
                }
            })
        }

        displayBookingsInMonthInCalendar(bookingDatesOfMonth,seatingDatesOfMonth)
    }

    async function displayBookingsInMonthInCalendar(bookingDatesOfMonth: number[],seatingDatesOfMonth: number[]){
        const elements = document.getElementsByClassName("calendar-date")
        const todayElement = document.getElementById("today-calendar-date")
        const todayDate = new Date()

        if(elements.length > 0){
            if(todayDate.getMonth() === monthYear.month && todayDate.getFullYear() === monthYear.year){
                if(todayElement){
                    // Add if booked today
                    if(bookingDatesOfMonth.includes(parseInt(todayElement.textContent as string))){
                        todayElement.appendChild(dot())
                    }
                } else {
                    await delay(250);
                }
            }

            // Add booking indicators
            for(var i=0; i<elements.length; i++){
                if(elements[i].textContent !== null){
                    var date = parseInt(elements[i].textContent as string) 
                    var dotElements = elements[i].getElementsByClassName("dot")
                    var circleElements = elements[i].getElementsByClassName("circle")

                    // Indication clean up
                    if(dotElements[0]){
                        elements[i].removeChild(dotElements[0])
                    }

                    if(circleElements[0]){
                        elements[i].removeChild(circleElements[0])
                    }

                    // Add booking indication´
                    if(bookingDatesOfMonth.includes(date)){
                        if(dotElements.length=== 0){
                            elements[i].appendChild(dot())
                        }
                    } else if (seatingDatesOfMonth.includes(date)) {
                        if(circleElements.length=== 0){
                            elements[i].appendChild(circle())
                        }
                    }
                }
            }
        } else {
            await delay(250);
            displayBookingsInMonthInCalendar(bookingDatesOfMonth, seatingDatesOfMonth)
        }
    }

    const dot = (): Element => {
        const dot = document.createElement("p");
        dot.setAttribute('class','dot')
        return dot
    }

    const circle = (): Element => {
        const circle = document.createElement("p");
        circle.setAttribute('class','circle')
        return circle
    }
    
    return (
        <div>
            <div className={classes.topbarContainer}>
                <div>
                    {showCheckOut || newBooking ?
                        <img src={icon_backButton} alt="backButton" onClick={() => { setShowCheckOut(false); setNewBooking(false) }} style={{ cursor: 'pointer' }} />
                        :
                        <div></div>
                    }
                </div>
                <Logo variant="small" />
                <img onClick={() => { setOpen(true) }} src={icon_hamburger} alt="hamburgerMenu" style={{ cursor: 'pointer' }} />
            </div>
            {!(showCheckOut) ?
                <div>
                    <Container maxWidth="xs">
                        {!bookedForToday || newBooking ?
                            <div>
                                <div className={classes.titleContainer}>
                                    <div className={classes.titles}>
                                        New booking
                                    </div>
                                    <div className={classes.flexEnd}>
                                        {
                                            offices &&
                                            <select
                                            //onChange = {handleChange}
                                            id="demo-customized-button"
                                            aria-controls="demo-customized-menu"
                                            aria-haspopup="true"
                                            className={classes.dropDownButton}
                                            value={officeContext?.office?.content.id}
                                            onChange={handleOfficeChange}>
                                            {offices.map((office) => <option value={office.content.id}>{office.content.officeName}</option>)}
                                            </select>
                                        }
                                    </div>
                                </div>
                                <div className="booking-datepicker-container">
                                    {
                                        selectedDate &&
                                        <MultiDateCalendarPicker minDate={minDate} selectedDate={selectedDate} setParentDate={setSelectedDate} />
                                    }
                                </div>
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    className={classes.menuItemContainer}
                                >
                                    <Grid key={"grid"} container>
                                        {
                                            selectedDate &&
                                            <div key={selectedDate.getTime()} className={clsx(classes.subTitle, classes.flexStart)}>
                                                {prettyDate(selectedDate, false, true)}
                                            </div>
                                        }
                                    </Grid>
                                    <div className={classes.menuItemsContainer}>
                                        {menuItemsOnDate.length > 0 ?
                                            menuItemsOnDateView
                                            :
                                            <div className={classes.noBookingsOnDateContainer}>No menu items on selected date</div>
                                        }
                                    </div>
                                </Grid>
                            </div>
                            :
                            <div>
                                <div className={classes.noBookingsOnDateContainer}>You are arealdy booked for today</div>
                                <Button className={classes.newBookingContainer} variant="outlined" onClick={() => { setNewBooking(true) }}>
                                    + New booking
                                </Button>
                            </div>

                        }
                        <div style={{marginBottom: 400}}>
                            {myBookingListView.length > 0 ?
                                <div className={classes.myBookingsContainer}>
                                    <div className={classes.upcomingBookingsHeader}>
                                        <div className={classes.titles}>
                                            Upcoming Bookings
                                        </div>
                                        <IconButton onClick={() => { sortFields() }}>
                                            <MdSort />
                                        </IconButton>
                                    </div>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        {myBookingListView}
                                    </Grid>
                                </div>
                                :
                                <div></div>
                            }
                        </div>
                        {isItemsSelected ?
                            <BottomNavigation className={classes.bottomNav}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{maxWidth:444}}
                                >   
                                    {
                                        priceTotal !== 0 ?
                                        <Grid className={classes.priceContainer}>
                                            <div className={classes.priceText}>{priceTotal}</div>
                                            <div className={classes.currencyText}>DKK</div>
                                        </Grid>
                                        :
                                        <div></div>
                                    }

                                    {isCorrectlyBooked ?

                                        <div
                                            onClick={() => { setShowCheckOut(true) }}
                                            className={classes.continueButton}>
                                            Continue <ArrowForwardIos />
                                        </div>

                                        :

                                        <div></div>

                                    }

                                </Grid>
                            </BottomNavigation>
                            :

                            <div></div>

                        }
                    </Container>
                </div>
                :

                <div>
                    <Container maxWidth="xs">
                        <div className={classes.titles}>
                            Checkout
                        </div>
                        <div className={classes.bookingInfoContainer}>
                            {checkOutView}
                        </div>
                        <div className={classes.checkOutTotalContainer} hidden={priceTotal=== 0}>
                            <div className={classes.checkOutPriceBold}>
                                TOTAL
                            </div>
                            <div className={classes.checkOutPriceContainer}>
                                <div className={classes.checkOutPriceBold}>
                                    {priceTotal}
                                </div>
                                <div className={classes.checkOutPriceNormal}>
                                    DKK
                                </div>
                            </div>
                        </div>
                        <div className={classes.checkOutPaymentContainer} onClick={() => { setCheckOutPaymentOption('invoice') }}>
                            <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                                <CustomCheckBox selected={checkOutPaymentOption=== 'invoice'} />
                            </div>
                            <div>
                                <div className={classes.checkOutPriceBold}>
                                    Add to your account
                                </div>
                                <div className={classes.checkOutSeatingInfoNormal}>
                                    Pay later by invoice
                                </div>
                            </div>
                        </div>
                    </Container>
                    {checkOutPaymentOption !== '' ?
                        <BottomNavigation className={classes.bottomNav}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                style={{maxWidth:444}}
                            >
                                <div
                                    onClick={() => { createBookings() }}
                                    className={classes.continueButton}>
                                    Checkout <ArrowForwardIos />
                                </div>
                            </Grid>
                        </BottomNavigation>
                        :
                        <div></div>
                    }
                </div>
            }
            <div>
                <HamburgerMenu open={open} setOpen={setOpen}>

                </HamburgerMenu>
            </div>
        </div>

    );
}
